import { apiDelete, apiGet, apiPatch, apiPost } from 'api/service';

export function listCves(params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiGet(`/api/cves/${query ? `?${query}` : ''}`);
}

export function getCve(cveId) {
  return apiGet(`/api/cves/${encodeURIComponent(cveId)}/`);
}

export function getCveStats(params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiGet(`/api/cves/stats/${query ? `?${query}` : ''}`);
}

export function getCveNews(params = {}) {
  const query = new URLSearchParams(params).toString();
  return apiGet(`/api/cves/news/${query ? `?${query}` : ''}`);
}

// ── CVE Nuclei Scan Jobs ──────────────────────────────────────────────────────

export function checkCveTemplate(cveId) {
  return apiGet(`/api/cve-scans/check_template/?cve_id=${encodeURIComponent(cveId)}`);
}

export function launchCveScan(cveId, targetUrl) {
  return apiPost('/api/cve-scans/', { cve_id: cveId, target_url: targetUrl });
}

export function getCveScanJob(jobId) {
  return apiGet(`/api/cve-scans/${jobId}/`);
}

export function listCveScanJobs(cveId) {
  const q = cveId ? `?cve_id=${encodeURIComponent(cveId)}` : '';
  return apiGet(`/api/cve-scans/${q}`);
}

// ── My technologies (watchlist with email alerts) ─────────────────────────────
export const listTechWatch = () => apiGet('/api/tech-watch/');
export const addTechWatch = (body) => apiPost('/api/tech-watch/', body);
export const updateTechWatch = (id, body) => apiPatch(`/api/tech-watch/${id}/`, body);
export const removeTechWatch = (id) => apiDelete(`/api/tech-watch/${id}/`);
export const techWatchHits = (id) => apiGet(`/api/tech-watch/${id}/hits/`);
export const checkTechWatch = (id) => apiPost(`/api/tech-watch/${id}/check/`);
export const suggestProducts = (q) => apiGet(`/api/tech-watch/suggest/?q=${encodeURIComponent(q)}`);
